import axios from 'axios'

export const certificateVerification = async (certificateNumber: string) => {
  const response = await axios.get(`/data/apliecības_pārbaude_pēc_numura/${certificateNumber}`)

  return response.data
}
